export default __webpack_public_path__ + "static/media/icon-feather-edit-black.f5fe8ad5.svg";